import { takeEvery, put } from 'redux-saga/effects';

import * as actionTypes from '../constants';
import { fetchElements } from '../slices/dataElements';

function* fetchSiteElement() {
  yield put(fetchElements({ ids: ['_site'] }));
}

export function* watchDataElementsSaga() {
  yield takeEvery(actionTypes.authentication.AUTHENTICATE, fetchSiteElement);
}
